import React, { useState } from 'react';
import { Col, Input, Row, Form, Checkbox } from "antd";
import { useSelector } from 'react-redux'
import { tPropertyBar, tSeat } from '../../../assets/libs/i18n/translator';
import { CategorySelect } from './CategorySelect';

const SeatsPropertiesPanel = ({ form, selectedItem }) => {
    const [accesible, setAccesible] = useState(selectedItem.accesible);
    const [companion, setCompanion] = useState(selectedItem.companion);
    const [restrictedView, setRestrictedView] = useState(selectedItem.restrictedView);

    const onCheckedAccesible = (e) => {
        const { target: { checked } } = e;
        setAccesible(checked);
        if (checked) {
            setCompanion(!checked);
        }
    }

    const onCheckedCompanion = (e) => {
        const { target: { checked } } = e;
        setCompanion(checked);
        if (checked) {
            setAccesible(!checked);
        }
    }

    const onCheckedRestrictedView = (e) => {
        const { target: { checked } } = e;
        setRestrictedView(checked);
    }


    const categories = useSelector(state => state.properties.categories);
    return (
        <Row>
            <Col span={24} className="mb-2"><h3 className="text-center">{tSeat("seats")}</h3></Col>
            <Col span={24} className="mb-1">
                <h3><b>{tPropertyBar("category")}</b></h3>
            </Col>
            <Col span={24}>
                <Form.Item wrapperCol={{ span: 24 }}>
                    {form('seatCategory', { initialValue: selectedItem.category.key })(
                        <CategorySelect categories={categories} />,
                    )}
                </Form.Item>
            </Col>
            <Col span={24} className="mb-1 mt-2"><h3><b>{tPropertyBar("seatLabeling")}</b></h3></Col>
            <Col span={24}>
                <Form.Item label={tPropertyBar("label")} labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
                    {form('seatLabel', {
                        initialValue: selectedItem.label,
                    })(<Input />)}
                </Form.Item>
                <Form.Item label={tPropertyBar("displayedLabel")} labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
                    {form('displayedSeatLabel', {
                        initialValue: selectedItem.displayedLabel,
                    })(<Input />)}
                </Form.Item>
            </Col>
            <Col span={24} className="mb-1 mt-2"><h3><b>{tSeat("icons")}</b></h3></Col>
            <Col span={24}>
                <Form.Item label={tSeat("restrictedView")} labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
                    {form('restrictedView', {
                        rules: [{ type: 'boolean', },],
                        initialValue: selectedItem.restrictedView,
                        checked: selectedItem.restrictedView
                    })(
                        <Checkbox checked={restrictedView} onClick={onCheckedRestrictedView} />)}
                </Form.Item>
                <Form.Item label={tSeat("accesible")} labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
                    {form('accesible', {
                        initialValue: selectedItem.accesible,
                        value: selectedItem.accesible,
                    })(
                        <Checkbox checked={accesible} onClick={onCheckedAccesible} />)}
                </Form.Item>
                <Form.Item label={tSeat("companion")} labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
                    {form('companion', {
                        initialValue: selectedItem.companion,
                        value: selectedItem.companion,
                    })(
                        <Checkbox checked={companion} onClick={onCheckedCompanion} />)}
                </Form.Item>
            </Col>
        </Row>
    );
}

export { SeatsPropertiesPanel };
